import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { AudioPlayerPill } from './ui';
export interface Character {
  id: string;
  name: string;
  hometown: string;
  color: string;
  borderColorClass: string;
  quote: string;
  bio?: string;
  catchphrases?: string[];
  isInterrupt?: boolean;
}
interface CharacterCardProps {
  character: Character;
  expanded?: boolean;
}
export const CharacterCard = ({
  character,
  expanded = false
}: CharacterCardProps) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const togglePlay = () => {
    setIsPlaying(!isPlaying);
    // In a real app, handle actual audio playback here
    if (!isPlaying) {
      setTimeout(() => setIsPlaying(false), 3000);
    }
  };
  return <motion.div whileHover={{
    y: -5
  }} className={`relative bg-dark rounded-2xl p-6 border-2 transition-all duration-300 flex flex-col h-full group ${character.borderColorClass} hover:shadow-[0_0_20px_rgba(255,255,255,0.1)]`} data-id="element-12">
      {/* Avatar Placeholder */}
      <div className="w-24 h-24 rounded-full bg-charcoal border-2 border-white/20 mx-auto mb-4 overflow-hidden relative" data-id="element-13">
        <div className={`absolute inset-0 opacity-20 ${character.borderColorClass.replace('border-', 'bg-')}`} data-id="element-14"></div>
        <div className="absolute inset-0 flex items-center justify-center text-4xl font-black font-heading text-white/30" data-id="element-15">
          {character.name.charAt(0)}
        </div>
      </div>

      {/* Header */}
      <div className="text-center mb-6" data-id="element-16">
        <h3 className="font-heading font-black text-3xl uppercase tracking-wide mb-1" data-id="element-17">
          {character.name}
        </h3>
        <p className="text-sm font-mono text-slate uppercase tracking-wider" data-id="element-18">
          {character.hometown}
        </p>
      </div>

      {/* Quote Bubble */}
      <div className="relative bg-charcoal p-4 rounded-xl rounded-tl-none mb-6 flex-1 border border-white/5" data-id="element-19">
        <div className="absolute -top-3 -left-0 w-4 h-4 bg-charcoal border-t border-l border-white/5 transform -skew-x-12" data-id="element-20"></div>
        <p className={`text-lg font-medium italic ${character.isInterrupt ? 'text-crimson font-bold' : 'text-white'}`} data-id="element-21">
          "{character.quote}"
        </p>
      </div>

      {/* Expanded Content */}
      {expanded && character.bio && <div className="mb-6 flex-1" data-id="element-22">
          <p className="text-sm text-slate mb-4" data-id="element-23">{character.bio}</p>
          {character.catchphrases && <div className="space-y-2" data-id="element-24">
              <p className="text-xs font-bold text-white uppercase tracking-wider" data-id="element-25">
                Signature Calls:
              </p>
              <ul className="text-sm text-slate space-y-1" data-id="element-26">
                {character.catchphrases.map((phrase, i) => <li key={i} className="flex gap-2" data-id="element-27">
                    <span className="text-lime" data-id="element-28">›</span> {phrase}
                  </li>)}
              </ul>
            </div>}
        </div>}

      {/* Footer Actions */}
      <div className="mt-auto flex flex-col gap-3" data-id="element-29">
        <AudioPlayerPill isPlaying={isPlaying} onClick={togglePlay} characterName="Play Sample" data-id="element-30" />

        {expanded && <button className="w-full py-3 rounded-lg font-bold uppercase tracking-wider text-sm border border-white/20 hover:bg-white hover:text-charcoal transition-colors" data-id="element-31">
            Add to My Cast
          </button>}
      </div>
    </motion.div>;
};